module.exports = __webpack_public_path__ + "img/banner_h501.f258bfe9.webp";